(function ($) {
    jQuery(document).ready(function () {
        class Tabrecall_Notify {
            constructor() {
                this.init();
            }
            init() {

                if(String(tabrecall?.options?.enabled).toLowerCase() === 'true'){
                    this.notify();
                }
            }
            notify() {
                let tabRecall = null;
                let userInteracted = false;
                
                
                // document title stuffs
                let msgIndex = 0;
                let msgBlinkInterval = null;
                const browserTitle = document.title;
                const msgDelay = tabrecall?.options?.delays?.message ?? 1000;

                // document icon stuffs
                let favicon = document.querySelector("link[rel~='icon']");
                let favIconIndex = 0;
                let favIconBlinkInterval = null;
                const iconDelay = tabrecall?.options?.delays?.icon ?? 1000;

                // audio stuffs
                let musicIndex = 0;
                let musicInterval = null;
                const musicDelay = tabrecall?.options?.delays?.music ?? 1000;

                /**
                 * Set user interaction flag when any user interaction happens to only trigger the audio play on user interaction
                 */
                document.addEventListener('click', () => {
                    userInteracted = true;
                });
                document.addEventListener('keydown', () => {
                    userInteracted = true;
                });

                const default_favicon = favicon?.href ?? tabrecall.options.default_favicon;

                const messages = tabrecall.options.messages;
                // push the default title to messages to loop between all title and the orginal page title
                messages.push(browserTitle);
                
                const icons = tabrecall.options?.icons ?? [];
                // push the default favicon to icons to loop between all icons and the original favicon
                icons.push(default_favicon);

                const musics = tabrecall.options.musics;

                /**
                 * using the smallest number as delay
                 */
                const delay = Math.min(msgDelay, iconDelay, musicDelay);
                const blink = tabrecall.options?.blink_enabled;
                // const msgBlinkDelay = tabrecall.options?.blink_delay ?? 1000;


                /**
                 * add audio element in dom to make notification sound
                 */
                const audioElement = document.createElement("audio");
                
                document.body.appendChild(audioElement);

                audioElement.addEventListener("timeupdate", () => {
                    if(audioElement.currentTime > (musicDelay * 0.99)){
                        audioElement.pause();
                        audioElement.currentTime = 0;
                    }
                });
                
                audioElement.addEventListener("loadeddata", function () {
                    audioElement.duration = 0;
                    audioElement.play()
                    musicIndex = ((musicIndex + 1) < musics.length) ? (musicIndex + 1) : 0;
                });

                document.addEventListener("visibilitychange", e => {

                    if (document.hidden) {
                        tabRecall = setTimeout(function () {
                            /**
                             * Previous copy where messages were a array of messages
                             */
                            // if (blink === 'true') {
                            //     let blinkCount = 0;
                            //     blinkInterval = setInterval(function () {
                            //         if (blinkCount % 2 === 0) {
                            //             document.title = messages;
                            //         } else {
                            //             document.title = browserTitle;
                            //         }
                            //         blinkCount++;
                            //     }, parseInt(blinkDelay))
                            // } else {
                            //     document.title = messages;
                            // }

                            /**
                             * loop through all messages
                             */
                            
                            

                            msgBlinkInterval = setInterval(function() {
                                document.title = messages[msgIndex]
                                msgIndex = ((msgIndex + 1) < messages.length) ? (msgIndex + 1) : 0;
                            }, parseInt(msgDelay));

                            /**
                             * Update the favicon
                             */
                            if (!favicon) {
                                favicon = document.createElement('link');
                                favicon.rel = 'icon';
                                document.head.appendChild(favicon);
                            }
                            
                            favIconBlinkInterval = setInterval(function(){
                                favicon.href = icons[favIconIndex];
                                favIconIndex = ((favIconIndex + 1) < icons.length) ? (favIconIndex + 1) : 0;
                            }, iconDelay);

                            musicInterval = setInterval(function() {
                                // audioElement.onload = () => {
                                    // };
                                audioElement.src = musics[musicIndex];
                                // audioElement.play();
                            }, musicDelay);


                            // if (userInteracted) {
                            //     audioElement.currentTime = 0;
                            //     audioElement.play().catch(error => {
                            //         console.log('Audio play failed:', error);
                            //     });
                            // }
                        }, parseInt(delay))
                    } else {
                        // if (tabRecall) {
                        //     clearTimeout(tabRecall);
                        // }
                        document.title = browserTitle;

                        if (favicon) {
                            favicon.href = default_favicon;
                        }

                        if (!audioElement.paused) {
                            audioElement.pause();
                        }

                        if(msgBlinkInterval) {
                            clearInterval(msgBlinkInterval);
                        }
                        msgIndex = 0;

                        if(favIconBlinkInterval) {
                            clearInterval(favIconBlinkInterval);
                        }
                        favIconIndex = 0;

                        if(musicInterval) {
                            clearInterval(musicInterval);
                        }
                        musicIndex = 0;
                    }

                })
            }
        }
        new Tabrecall_Notify();
    })
})(jQuery)
